import { Component, OnInit, Input, ElementRef, Renderer2 } from '@angular/core';
import { WidgetComponent } from '../widget/widget.component';
import { TableComponent } from '../table.component';
import { TableElement } from '../table.element';
import { TableColumn } from '../table.column';

@Component({
  selector: 'app-table-widget-boolean',
  templateUrl: './boolean.component.html',
  styleUrls: ['./boolean.component.scss']
})
export class BooleanComponent extends WidgetComponent implements OnInit {

  _boolean: string;
  @Input() set boolean(_boolean: string) {
    this._boolean = 'status ' + _boolean;
  }
  get boolean(): string {
    return this._boolean;
  }

  // tslint:disable-next-line: deprecation
  constructor(ngEl: ElementRef, renderer: Renderer2) {
    super(ngEl, renderer);
  }

  ngOnInit() {
  }

  public setContent(table: TableComponent, tableElement: TableElement, tableColumn: TableColumn): void {
    super.setContent(table, tableElement, tableColumn);

    this.boolean = this.getContent();
  }
}
